import styles from "@/styles/site-map.module.scss"
import Head from "next/head"
import { useEffect, useState } from "react";
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import { DownOutlined } from '@ant-design/icons';
import { Tree, Skeleton } from 'antd';
import type { TreeDataNode, TreeProps } from 'antd';
import homeApi from '@/service/modules/homeApi'

export default function SiteMap() {
  const [treeData, setTreeData] = useState<TreeDataNode[] | undefined>(undefined);

  function transformToTreeData(categories: any) {
    return categories.map((category: any) => ({
      title: category.name,
      key: `root-product_${category.url || category.categoryID.toString()}`,
      children: category.subCategories ? transformToTreeData(category.subCategories) : []
    }));
  }

  // 获取分类数据
  const getCategoryData = async () => {
    try {
      let res = await homeApi.getCategoryTree()
      if (res.data && res.data.tree) {
        const additionalTreeData = transformToTreeData(res.data.tree);

        const existingChildren = [
          { title: 'Clearance', key: '/clearance', children: [] },
          { title: 'Free Shipping', key: '/free-shipping', children: [] },
          { title: 'Top Reviewed', key: '/top-reviewed-1', children: [] },
          { title: 'Cheap Discount', key: '/cheap-discount-1', children: [] },
          { title: 'Featured Deals', key: '/featured-deals', children: [] },
          { title: 'Hottest Deals', key: '/hottest-deals', children: [] },
          { title: 'New Arrivals', key: '/newarrival', children: [] },
          { title: 'Special Promotions', key: '/special-promotions', children: [] }
        ];

        const productListData = [
          {
            title: 'Product Lists',
            key: 'product-lists',
            children: [...existingChildren, ...additionalTreeData]
          }
        ];

        setTreeData([
          {
            "title": "Home - BestDeals - Where the real deals are!",
            "key": "root_/",
            "children": []
          },
          {
            "title": "New Arrivals",
            "key": "root_/newarrival",
            "children": []
          },
          {
            "title": "Best Sellers",
            "key": "root_/bestseller",
            "children": []
          },
          {
            "title": "Clearance Sale",
            "key": "root_/clearance",
            "children": []
          },
          {
            "title": "Register",
            "key": "root_/login",
            "children": []
          },
          {
            "title": "About Us",
            "key": "root_/article/AboutUs",
            "children": []
          },
          {
            "title": "Help centre",
            "key": "root_/article/faq",
            "children": []
          },
          {
            "title": "Contact Us",
            "key": "root_/contact-us",
            "children": []
          },
          {
            title: `Product Lists`,
            key: '',
            children: [
              {
                title: 'Clearance',
                key: 'root-product_/clearance',
                children: []
              },
              {
                title: 'Free Shipping',
                key: 'root-product_/free-shipping',
                children: []
              },
              {
                title: 'Top Reviewed',
                key: 'root-product_/top-reviewed-1',
                children: []
              },
              {
                title: 'Cheap Discount',
                key: 'root-product_/cheap-discount-1',
                children: []
              },
              {
                title: 'Featured Deals',
                key: 'root-product_/featured-deals',
                children: []
              },
              {
                title: 'Hottest Deals',
                key: 'root-product_/hottest-deals',
                children: []
              },
              {
                title: 'New Arrivals',
                key: 'root-product_/newarrival',
                children: []
              },
              {
                title: 'Special Promotions',
                key: 'root-product_/special-promotions',
                children: []
              },

              ...productListData
            ]
          }
        ])
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getCategoryData()
  }, [])

  // 点击树节点，触发跳转
  const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
    let url = String(info.node.key).substring(String(info.node.key).indexOf("_") + 1)
    window.location.href = url
  };

  return (
    <>
      <Head>
        <title>
          Online Shopping in New Zealand: Discount Store - BestDeals.co.nz
        </title>
        <meta
          name="keywords"
          content=""
        ></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout >
        <div className={`${styles['page-site-map']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles['content']}>
          {
            treeData 
            ?
            <Tree
              showLine
              switcherIcon={<DownOutlined />}
              defaultExpandAll={true}
              onSelect={onSelect}
              treeData={treeData}
            />
            :
            <>
              <Skeleton style={{ marginBottom: '60px' }}></Skeleton>
              <Skeleton style={{ marginBottom: '60px' }}></Skeleton>
              <Skeleton style={{ marginBottom: '60px' }}></Skeleton>
              <Skeleton></Skeleton>
            </>
          }
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}